/**
 * Moves the item with specified prop to the front of the array.
 * @param {any[]} arr - An array of objects.
 * @param {number} specifiedID - The ID of the object to be moved to the front.
 * @param {string} prop - The property name to check for moving.
 */
export function moveItemToFrontByProp(arr, specifiedID, prop) {
  return [...arr].sort((a, b) => {
    if (a[prop] === specifiedID) {
      return -1;
    } if (b[prop] === specifiedID) {
      return 1;
    }
    return 0;
  });
}
